import { useEffect } from "react";
import { tryEmbedCssLink } from "../../../../utils/embed-utils";
import { DtoPublicTest } from "@/types/dto-types";

export function useCssLinks(publicTest: DtoPublicTest) {
  useEffect(() => {
    const { cssLink: testCssUrl, client, group } = publicTest;
    let cssLink: HTMLLinkElement | undefined = undefined;

    if (group?.cssLink) {
      cssLink = tryEmbedCssLink(group.cssLink);
    } else if (testCssUrl) {
      cssLink = tryEmbedCssLink(testCssUrl);
    } else if (client?.cssLink) {
      cssLink = tryEmbedCssLink(client.cssLink);
    }

    return () => {
      if (cssLink) {
        cssLink.remove();
      }
    };
  }, [publicTest]);
}
